function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg403Error(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-23"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 407.17,
    y: 317.02,
    width: 26.48,
    height: 11.19,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 392.4,
    y: 331.13,
    width: 26.48,
    height: 11.19,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 421.94,
    y: 331.13,
    width: 26.48,
    height: 11.19,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.35,
    y: 317.02,
    width: 26.48,
    height: 11.19,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 51.57,
    y: 331.13,
    width: 26.48,
    height: 11.19,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 234.25,
    y: 227.76,
    width: 26.48,
    height: 11.19,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 219.47,
    y: 241.87,
    width: 26.48,
    height: 11.19,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 347.4,
    y: 114.93,
    width: 26.48,
    height: 11.19,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 249.02,
    y: 241.87,
    width: 26.48,
    height: 11.19,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 405.64,
    y: 55.18,
    width: 26.48,
    height: 11.19,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 420.41,
    y: 69.29,
    width: 26.48,
    height: 11.19,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 51.57,
    y: 55.19,
    width: 26.48,
    height: 11.19,
    style: {
      fill: "#ebebeb"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-23"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 323.63,
    cy: 450.27,
    rx: 116.72,
    ry: 14.46,
    style: {
      fill: "#ebebeb"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plants--inject-23"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M68.69,378.15c-4.38.15-9.26.4-12.88-2.44-3.35-2.62-6.34-6.52-5.89-11,.13-1.28.42-2.07,1.79-1.53,2.09.84,3.69,3.14,5.14,4.75a44.08,44.08,0,0,0,6.07,5.76c1.56,1.2,3.23,2.23,4.82,3.38l.6.45.22.17h.13a.23.23,0,0,1,.18.09s0,.05,0,.08A.23.23,0,0,1,68.69,378.15Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.9,377.86c-3.84-.07-8,.11-11.07-2.5A17.84,17.84,0,0,1,54.25,371c-.44-.72-1.77-2.88-1.22-3.74,1-1.55,5.58,4.78,6.22,5.39a18.7,18.7,0,0,0,8.49,4.41l.6.45A21.31,21.31,0,0,1,62,375.07c-2.73-1.63-4.25-4-6.39-6.29-.46-.49-1.85-2.12-2.38-1.1-.34.67,1,2.78,1.22,3.23A17.72,17.72,0,0,0,57.79,375c3.07,2.68,7.2,2.58,11.08,2.74C68.88,377.81,68.9,377.83,68.9,377.86Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.1,380.82c0,.16-.07.33-.11.5v0a.11.11,0,0,1-.08.09.19.19,0,0,1-.23-.09.11.11,0,0,1,0-.11.14.14,0,0,1,0-.06l0-.15v0a.07.07,0,0,1,0-.05c-.78-2.89-1.08-5.9-1.9-8.8s-1.75-5.48-2.31-8.3c-.35-1.78-1.59-10.71,2.34-9.59,1.75.49,2.94,3,3.6,4.52a18.24,18.24,0,0,1,1.45,6.42C74.2,370.64,72.2,375.6,71.1,380.82Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.36,369.7a21.29,21.29,0,0,0-.63-6.06c-.18-.68-1-4-2.14-3.89-.72.05-.85,1.47-.91,1.94-.25,2,.4,4,.78,5.95a81.17,81.17,0,0,1,1.45,11.92c0,.25-.08.51-.1.76s-.06.42-.09.63,0,.14,0,.22a.88.88,0,0,0,0,.17.19.19,0,0,0,.23.09c0-.17,0-.33.07-.49,0,.13,0,.26,0,.4h0c0-.15,0-.28.08-.42a.29.29,0,0,1,0-.09c0-.23,0-.45,0-.67A87.94,87.94,0,0,0,72.36,369.7Zm-1.33,9c-.11-2.34-.34-4.67-.67-7-.27-1.87-.62-3.72-1-5.57a17.77,17.77,0,0,1-.5-3.16c0-.81.08-3.83,1.63-2,1.12,1.36,1.39,4.24,1.53,5.9a31.06,31.06,0,0,1-.11,5.54C71.69,374.56,71.34,376.64,71,378.71Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.46,392.82h0a.64.64,0,0,1-.16,0c-4-.2-9.33.18-12.66-2.47-2.46-2-4.87-5.82-4.09-9.1.88-3.69,5.87.74,7.19,1.81a121.75,121.75,0,0,1,9.81,9.54.18.18,0,0,0,0,.07h0C73.63,392.77,73.55,392.8,73.46,392.82Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.59,392.71l-.69-.44Q69,389.8,65.24,387c-.62-.48-5.12-4.49-5.8-3.06-.41.87,1.08,2.63,1.55,3.23a12.5,12.5,0,0,0,3,2.72c2.67,1.66,5.9,2,8.92,2.82a2.47,2.47,0,0,1,.43.11l.07,0h0C73.55,392.8,73.63,392.77,73.59,392.71Zm-7.91-2.28a12.43,12.43,0,0,1-3.46-2.34c-.67-.63-3-3-2.4-4,.33-.52.61-.25,1.24.07a6.47,6.47,0,0,1,.85.49c.67.44,1.29.95,1.92,1.45,1.09.88,2.21,1.73,3.35,2.55q2.79,2,5.72,3.85C70.5,391.75,68,391.46,65.68,390.43Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.77,384.58a23.69,23.69,0,0,1-6.86,12s0,0-.08,0a.17.17,0,0,1-.2-.07.16.16,0,0,1,0-.23l.2-.21c.66-5.44,1.39-10.85,2-16.3.13-1.29,1.14-9.47,3.66-8.14,1.55.83,1.65,4.18,1.78,5.69A23.82,23.82,0,0,1,80.77,384.58Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.31,377.29c-.13-.46-.37-.92-.88-.6-1,.61-1.36,4.45-1.53,5.52-.67,4.39-1.71,8.61-2.76,12.9l-.27,1.09-.24.33a.18.18,0,0,0,.2.07s0-.07,0-.11.22-.29.32-.44h0a28.1,28.1,0,0,0,4-7.72A26.09,26.09,0,0,0,79.32,383C79.51,381.26,79.82,378.94,79.31,377.29Zm-5.13,18.46L74,396c0-.15.09-.29.13-.44a77.85,77.85,0,0,0,2.45-10c.29-1.71.48-3.44.83-5.14.15-.72.5-2.78,1.1-3.11s.58.47.64.93,0,.93,0,1.25A27.57,27.57,0,0,1,74.18,395.75Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.57,408.29h-.8c0-.71,0-1.41,0-2.11-.09-2.84-.21-5.68-.38-8.53-.09-1.62-.21-3.23-.38-4.82,0-.05,0-.11,0-.16s0-.26,0-.4,0-.27-.05-.42a34.61,34.61,0,0,0-2.75-10.44c-.51-1.11-1.06-2.19-1.65-3.26,0-.1-.11-.2-.17-.3a.2.2,0,0,0,0-.09l-.17-.32-.14-.23c-1.85-3.26-4-6.37-6-9.51-.58-.89-1.16-1.79-1.72-2.7a.86.86,0,0,1-.1-.16,1.37,1.37,0,0,1-.13-.2c-2.52-4-5-8-7.62-11.9-.11-.14.13-.27.23-.13,1.77,2.59,3.6,5.14,5.42,7.71l.72,1c.48.68,1,1.35,1.43,2,1,1.36,1.89,2.71,2.8,4.09a113,113,0,0,1,7.37,11.92c.16.31.31.62.46.94s.19.39.27.59.21.46.31.69a36.66,36.66,0,0,1,2.69,12.6l.06.91c0,.13,0,.28,0,.42a1.64,1.64,0,0,0,0,.22c0,.1,0,.19,0,.3h0c0,.07,0,.14,0,.22l0,.78c.12,2.84.19,5.68.25,8.52C74.5,406.47,74.54,407.38,74.57,408.29Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.69,356.8c-2.19-2.95-5-9-1.77-12.18a3.42,3.42,0,0,1,4.57-.34c1.71,1.23,2.47,3.56,3,5.49,1.48,5.16,2.46,10.41,4.3,15.46a5.63,5.63,0,0,1,.21.54c0,.11-.13.15-.17.05s-.12-.33-.19-.49C57.19,362.79,53.28,360.29,50.69,356.8Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.85,365.24l-.05-.09a34.93,34.93,0,0,1-2-3.81,74.88,74.88,0,0,1-3.15-8.44c-.35-1.1-1.92-6.52-3.86-4.36-.81.91-.69,2.52-.57,3.63a13.63,13.63,0,0,0,1.69,5.07,24.64,24.64,0,0,0,7.27,7.6l.39.29a1,1,0,0,0,.08.14.41.41,0,0,0,0,.09.1.1,0,0,0,.05,0,.13.13,0,0,0,.17-.08A.07.07,0,0,0,60.85,365.24Zm-.85-.6a28.93,28.93,0,0,1-6.17-6.18,15.29,15.29,0,0,1-2-4.1,12,12,0,0,1-.44-2,8.51,8.51,0,0,1-.09-1.52c0-1.11.5-2.32,1.16-2.44s1.08.33,1.62,1.26a9.85,9.85,0,0,1,.48,1,26,26,0,0,1,.91,2.56c.45,1.44.91,2.86,1.43,4.27.35,1,.72,1.91,1.13,2.84a36.64,36.64,0,0,0,2.4,4.66A4.58,4.58,0,0,1,60,364.64Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.69,365c-.36,2.92-.92,5.82-1.51,8.7-.34,1.63-.69,3.26-1,4.9-.36,1.8-.9,3.64-.41,5.46h0a1.14,1.14,0,0,1,0,.25l0,0a.22.22,0,0,1-.38-.06l0-.13,0,0a6.75,6.75,0,0,1-.63-1.52,38.89,38.89,0,0,1-1.45-4.22,36.65,36.65,0,0,1-1.42-9,30.78,30.78,0,0,1,.85-8.11c.52-2.12,1.26-5.28,2.84-6.9,1.43-1.47,2.62.88,3,2.07C432.48,359.16,432,362.27,431.69,365Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.07,358.84c-1.06,0-1.84,3.44-2.22,4.92a29.84,29.84,0,0,0-.9,7.17,38.32,38.32,0,0,0,2.2,12.72c.05.16.11.33.17.5l0,0,0,.11a.22.22,0,0,0,.38.07c-.07-.36-.12-.71-.16-1.07s-.08-.65-.1-1a51,51,0,0,1,.65-10.54C429.67,367.73,430.48,358.84,429.07,358.84ZM428.31,383c.05.48.13.94.21,1.41-.11-.34-.21-.68-.32-1a42.88,42.88,0,0,1-2-11.23,28.9,28.9,0,0,1,1.29-9.77c.15-.47.92-3.34,1.58-3.2.46.1.57,2.69.58,2.75,0,.51,0,1,0,1.56,0,1.07-.09,2.14-.18,3.21-.2,2.31-.53,4.62-.81,6.92A40.3,40.3,0,0,0,428.31,383Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.46,373.1c-2,3.81-5.25,6.73-8.65,9.24-1.83,1.34-3.71,2.59-5.56,3.89a29.8,29.8,0,0,0-4.8,3.69l-.19.2a7.68,7.68,0,0,0-1,1.37.12.12,0,0,1-.09.06,1.22,1.22,0,0,1-.07.17,0,0,0,0,1-.07,0,1.23,1.23,0,0,1,0-.19h0a.13.13,0,0,1,0-.15l0-.06,0-.19c.56-4.46,3.67-9,6.31-12.39a23.68,23.68,0,0,1,10-8c1-.39,3.35-1.47,4.39-.64S448.87,372.29,448.46,373.1Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.43,373.12c-.92-.93-3.66,1.36-4.34,1.9a44.58,44.58,0,0,0-5.66,5.5A40.79,40.79,0,0,0,428.2,391h0l-.09.12,0,.19,0,.06a.12.12,0,0,0,0,.15l.14-.16c.34-.42.7-.82,1.06-1.22a1.8,1.8,0,0,1,.19-.2,87.36,87.36,0,0,1,8.46-7.47,42.79,42.79,0,0,0,5.63-5.47C444,376.46,446.21,373.9,445.43,373.12Zm-.85,2c-2.31,3.82-6.3,6.62-9.69,9.41a46,46,0,0,0-6.44,6.11,43.23,43.23,0,0,1,6.68-9.4,58.59,58.59,0,0,1,4.59-4.73,25,25,0,0,1,2.79-2.23,9,9,0,0,1,1.89-1C445.69,372.92,445,374.5,444.58,375.16Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.65,400.57a.23.23,0,0,1-.2.11l.05.07a.07.07,0,0,1,0,.1.08.08,0,0,1-.1,0c-3.61-3.68-7.09-8.15-8.89-13a20.1,20.1,0,0,1-1.29-6.41c0-1.5-.12-4.52,1.16-5.61,2.58-2.2,4.94,7.12,5.29,8.53.64,2.56,1.06,5.17,1.65,7.74.65,2.82,1.5,5.58,2.34,8.34A.19.19,0,0,1,427.65,400.57Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.65,400.57c-.14-.24-.28-.48-.41-.72a43.54,43.54,0,0,1-4.65-12.52,39.62,39.62,0,0,0-1.72-6.52c-.21-.52-.85-2.5-1.71-1.5-.44.52-.07,4.29.1,5.26a27.59,27.59,0,0,0,2.1,6.4,45.35,45.35,0,0,0,5.92,9.62l.21.26a.07.07,0,0,0,0-.1l-.05-.07A.23.23,0,0,0,427.65,400.57Zm-5.25-8a32.81,32.81,0,0,1-2.48-6.22,22.79,22.79,0,0,1-.54-2.61,14.6,14.6,0,0,1-.18-2.08c0-1.7.15-2.14.44-2.2s.42.15.92,1.16a11.84,11.84,0,0,1,.73,2.07c.26,1,.49,2,.71,3,.44,2,.85,4.07,1.44,6.06a33.87,33.87,0,0,0,3.59,8.15A52.34,52.34,0,0,1,422.4,392.56Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.24,391.63a12.82,12.82,0,0,1-2.37,4.93c-2.15,3-4.89,5.43-7.23,8.23-.35.41-.69.84-1,1.28,0,.05-.31.66-.3.61l.11-.64h0c.37-2,1.61-7.88,3.14-10.91a26.68,26.68,0,0,1,3.43-5.36c.66-.75,2.22-2.37,3.39-2S439.42,390.69,439.24,391.63Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.33,390.44c-1.26-.78-4.49,5-4.93,5.74a37.21,37.21,0,0,0-3.69,8.81c-.1.35-.19.69-.27,1.05l-.13.64s.27-.56.31-.62l.17-.22c.28-.36.56-.71.85-1,1.4-2.1,2.84-4.19,4.21-6.32a34.33,34.33,0,0,0,2.61-4.81C436.62,393.28,437.88,390.77,437.33,390.44Zm-.36,1.62c-1.79,5-5.43,9-8.21,13.45l-.13.22c0-.13.07-.26.11-.39a42,42,0,0,1,2.95-7.34,39.4,39.4,0,0,1,2.48-4.14,20.57,20.57,0,0,1,1.55-2.15c.26-.28,1-1,1.25-.91S437.08,391.73,437,392.06Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.84,350.15c-3.73,8.56-13.52,12.55-17.76,20.81l0,0c-.13.25-.25.51-.37.77a.17.17,0,0,1-.28.05.16.16,0,0,1,0-.15l.09-.18a44.64,44.64,0,0,1,5.24-15c2.14-3.95,5.07-7.64,9.14-9.72,1-.52,2.95-1.6,4.07-.75S452.3,349.09,451.84,350.15Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.48,350.51c-.47-.35-1.19.08-1.6.29a14.44,14.44,0,0,0-2.83,1.93,23.49,23.49,0,0,0-4.51,5.37,48.5,48.5,0,0,0-5.32,10.78c-.28.86-.53,1.73-.74,2.61,0,.11-.05.22-.07.32a.17.17,0,0,0,.28,0c.11-.25.23-.49.36-.74,0,0,0,0,0-.07a28.18,28.18,0,0,1,2.66-4.88,65.34,65.34,0,0,1,5.58-6.62C443.08,358.61,450.12,351.72,448.48,350.51Zm-.6,2a32.3,32.3,0,0,1-4.42,5.36c-1.55,1.73-3.11,3.44-4.63,5.19a32.75,32.75,0,0,0-3.27,4.46,25.46,25.46,0,0,0-2,4.12,36.11,36.11,0,0,1,1.46-4.29l0,0a64.67,64.67,0,0,1,3.61-7.21.26.26,0,0,0,.05-.09,29.62,29.62,0,0,1,4.13-5.75,16.28,16.28,0,0,1,2.93-2.5c1.23-.79,2.3-1.31,2.61-.92S448.22,351.91,447.88,352.5Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.81,360.19c-1.12,2.41-2.19,4.86-3.25,7.32-.5,1.15-1,2.3-1.48,3.45,0,0,0,.05,0,.07l-.54,1.25a76.31,76.31,0,0,0-4.38,11.58,35.29,35.29,0,0,0-.89,6.44c0,.22,0,.45,0,.67h0v.36a1.48,1.48,0,0,0,0,.21c-.07,1.88,0,3.76,0,5.59.05,2.56.27,5.1.51,7.63a1.64,1.64,0,0,0,0,.22l0,.35c0,.06,0,.11,0,.17l0,.33c.08.81.15,1.63.22,2.45h-.78a51.28,51.28,0,0,1-.94-7.54.92.92,0,0,1,0-.16c0-.24,0-.5,0-.74s0-.6,0-.91c0-.73-.05-1.46-.06-2.18a53.5,53.5,0,0,1,.9-12.63c0-.11,0-.22.08-.34a.89.89,0,0,1,0-.14,2,2,0,0,1,.05-.24l.11-.39c.06-.23.13-.46.19-.68l.06-.21a83.69,83.69,0,0,1,4.31-10.4l.86-1.83c.17-.34.33-.68.49-1l.76-1.54,0,0c1.19-2.41,2.43-4.79,3.61-7.21C438.68,360,438.87,360.07,438.81,360.19Z",
    style: {
      fill: "#37474f"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Fence--inject-23"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 126.96,
    y: 355.81,
    width: 177.6,
    height: 23.52,
    style: {
      fill: "#009595"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "163.46 355.81 150.57 379.33 127.64 379.33 140.53 355.81 163.46 355.81",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "210.48 355.81 197.59 379.33 174.65 379.33 187.53 355.81 210.48 355.81",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "257.49 355.81 244.6 379.33 221.66 379.33 234.55 355.81 257.49 355.81",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "304.5 355.81 291.61 379.33 268.67 379.33 281.56 355.81 304.5 355.81",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "270.39 409.18 294.82 409.18 276.72 298.21 252.3 298.21 270.39 409.18",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "140.12 409.18 164.55 409.18 146.46 298.21 122.03 298.21 140.12 409.18",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "280.39 409.18 304.82 409.18 286.72 298.21 262.3 298.21 280.39 409.18",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "140.12 409.18 164.55 409.18 146.46 298.21 122.03 298.21 140.12 409.18",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "136.8 298.22 135.28 307.56 133.65 317.6 118.71 409.18 94.29 409.18 109.22 317.6 110.86 307.56 112.38 298.22 136.8 298.22",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.27,298.22c-1.29,9.27-2.67,18.53-4.07,27.79l-4.31,27.76-4.51,27.72-2.33,13.85-2.43,13.84,2-13.9,2.08-13.9L124,353.63l4.51-27.73C130.05,316.67,131.61,307.43,133.27,298.22Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "135.28 307.56 133.65 317.6 109.22 317.6 110.86 307.56 135.28 307.56",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "277.07 298.22 275.55 307.56 273.91 317.6 258.98 409.18 234.55 409.18 249.49 317.6 251.13 307.56 252.65 298.22 277.07 298.22",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.46,298.22c-1.29,9.27-2.67,18.53-4.07,27.79l-4.31,27.76-4.51,27.72-2.33,13.85-2.43,13.84,2-13.9,2.08-13.9,4.31-27.75,4.51-27.73C270.24,316.67,271.8,307.43,273.46,298.22Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "275.55 307.56 251.13 307.56 249.49 317.6 273.91 317.6 275.55 307.56",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96.7,
    y: 360.03,
    width: 177.6,
    height: 23.52,
    style: {
      fill: "#009595"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "133.2 360.03 120.31 383.55 97.38 383.55 110.27 360.03 133.2 360.03",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "180.22 360.03 167.33 383.55 144.39 383.55 157.28 360.03 180.22 360.03",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "227.23 360.03 214.34 383.55 191.4 383.55 204.29 360.03 227.23 360.03",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "274.24 360.03 261.35 383.55 238.41 383.55 251.3 360.03 274.24 360.03",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96.7,
    y: 265.5,
    width: 209.5,
    height: 42.07,
    style: {
      fill: "#009595"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "139.76 265.5 124.56 307.56 97.5 307.56 112.71 265.5 139.76 265.5",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "195.22 265.5 180.02 307.56 152.95 307.56 168.16 265.5 195.22 265.5",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "250.67 265.5 235.47 307.56 208.41 307.56 223.62 265.5 250.67 265.5",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "306.13 265.5 290.93 307.56 263.86 307.56 279.07 265.5 306.13 265.5",
    style: {
      fill: "#ebebeb"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-23"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "43.94 408.97 95.45 408.73 146.97 408.64 250 408.47 353.03 408.64 404.55 408.73 456.06 408.97 404.55 409.22 353.03 409.31 250 409.47 146.97 409.3 95.45 409.22 43.94 408.97",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Sign--inject-23"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 73.16,
    y: 52.27,
    width: 151.44,
    height: 180.05,
    style: {
      fill: "#009595"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 148.88,
    cy: 92.56,
    r: 25.76,
    transform: "translate(-23.9 62.91) rotate(-22.13)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.88,115.21a22.65,22.65,0,1,1,22.65-22.65A22.67,22.67,0,0,1,148.88,115.21Zm0-43.53a20.88,20.88,0,1,0,20.88,20.88A20.9,20.9,0,0,0,148.88,71.68Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--evN0z7--inject-23"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M141.89,95.24l0,0-.06-.08c-.61-.84-1.21-1.68-1.84-2.5a2.88,2.88,0,0,0-.69-.66,1.89,1.89,0,0,0-2.91,1.13,2.11,2.11,0,0,0,.33,1.72l4.8,7.28A7.63,7.63,0,0,0,145,105.1a11.52,11.52,0,0,0,7.72.43,6.15,6.15,0,0,0,4.09-3.55,7.87,7.87,0,0,0,.69-3.27c0-3,0-6,0-8.95,0-1.61,0-3.22,0-4.83a1.62,1.62,0,0,0-.61-1.33,1.55,1.55,0,0,0-1.73-.21,1.53,1.53,0,0,0-.94,1.48c0,2.17,0,4.33,0,6.5,0,.37-.15.57-.42.57s-.41-.2-.41-.57V82a2.68,2.68,0,0,0,0-.4,1.63,1.63,0,0,0-3.25.22v8.49a1.93,1.93,0,0,1,0,.24.41.41,0,0,1-.39.36.39.39,0,0,1-.41-.33,1.1,1.1,0,0,1,0-.26V80.91a2.35,2.35,0,0,0,0-.26,1.56,1.56,0,0,0-.79-1.29A1.62,1.62,0,0,0,146,80.77q0,4.78,0,9.55a1.61,1.61,0,0,1,0,.22.42.42,0,0,1-.41.37.41.41,0,0,1-.41-.35,1.55,1.55,0,0,1,0-.22V86.79c0-1.32,0-2.65,0-4a1.63,1.63,0,1,0-3.26.05V95.24Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.89,95.24V82.87a1.63,1.63,0,1,1,3.26-.05c0,1.32,0,2.65,0,4v3.55a1.55,1.55,0,0,0,0,.22.41.41,0,0,0,.41.35.42.42,0,0,0,.41-.37,1.61,1.61,0,0,0,0-.22q0-4.77,0-9.55a1.62,1.62,0,0,1,2.46-1.41,1.56,1.56,0,0,1,.79,1.29,2.35,2.35,0,0,1,0,.26v9.41a1.1,1.1,0,0,0,0,.26.39.39,0,0,0,.41.33.41.41,0,0,0,.39-.36,1.93,1.93,0,0,0,0-.24V81.82a1.63,1.63,0,0,1,3.25-.22,2.68,2.68,0,0,1,0,.4v9.37c0,.37.14.57.41.57s.42-.2.42-.57c0-2.17,0-4.33,0-6.5a1.53,1.53,0,0,1,.94-1.48,1.55,1.55,0,0,1,1.73.21,1.62,1.62,0,0,1,.61,1.33c0,1.61,0,3.22,0,4.83,0,3,0,6,0,8.95a7.87,7.87,0,0,1-.69,3.27,6.15,6.15,0,0,1-4.09,3.55,11.52,11.52,0,0,1-7.72-.43,7.63,7.63,0,0,1-3.48-2.95l-4.8-7.28a2.11,2.11,0,0,1-.33-1.72A1.89,1.89,0,0,1,139.25,92a2.88,2.88,0,0,1,.69.66c.63.82,1.23,1.66,1.84,2.5l.06.08Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 77.93,
    cy: 56.94,
    r: 1.68,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 219.84,
    cy: 56.94,
    r: 1.68,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 77.93,
    cy: 227.66,
    r: 1.68,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 219.84,
    cy: 227.66,
    r: 1.68,
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Texts--inject-23"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M110.15,184.44V174H89.68v-8.34l23.48-30.14h6.38v30.07h6.17V174h-6.17v10.44ZM99.07,165.59H111.2V149.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.91,155a25.55,25.55,0,0,1-1.37,8.52,21,21,0,0,1-3.78,6.73,17.22,17.22,0,0,1-5.75,4.42,17.32,17.32,0,0,1-14.41,0,17.37,17.37,0,0,1-5.71-4.42,21,21,0,0,1-3.78-6.73,27.15,27.15,0,0,1,0-17,20.9,20.9,0,0,1,3.78-6.73,17.6,17.6,0,0,1,5.71-4.45,16.83,16.83,0,0,1,14.41,0,17.44,17.44,0,0,1,5.75,4.45,20.9,20.9,0,0,1,3.78,6.73A25.53,25.53,0,0,1,167.91,155Zm-9.46,0a19.91,19.91,0,0,0-.63-5.15,13.07,13.07,0,0,0-1.79-4,8.42,8.42,0,0,0-2.74-2.59,6.76,6.76,0,0,0-3.47-.91,7,7,0,0,0-3.54.91,8.49,8.49,0,0,0-2.73,2.59,13.07,13.07,0,0,0-1.79,4,19.91,19.91,0,0,0-.63,5.15,19.46,19.46,0,0,0,.63,5.12,13.11,13.11,0,0,0,1.79,4,8.49,8.49,0,0,0,2.73,2.59,7,7,0,0,0,3.54.91,6.76,6.76,0,0,0,3.47-.91,8.42,8.42,0,0,0,2.74-2.59,13.11,13.11,0,0,0,1.79-4A19.46,19.46,0,0,0,158.45,155Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.05,159a11.17,11.17,0,0,1,7,4.17,13,13,0,0,1,2.7,8.31,13.54,13.54,0,0,1-1.3,6,13,13,0,0,1-3.65,4.52,17.2,17.2,0,0,1-5.71,2.87,26.06,26.06,0,0,1-7.57,1,24.36,24.36,0,0,1-9.43-1.72,17.63,17.63,0,0,1-6.83-5l5.32-6.66A12.83,12.83,0,0,0,183,176a14.07,14.07,0,0,0,6.31,1.27,10.76,10.76,0,0,0,6.52-1.69,6.07,6.07,0,0,0,2.24-5.18,6.61,6.61,0,0,0-2.59-5.61q-2.6-2-7.85-2h-2v-7h2.18a10.49,10.49,0,0,0,6.73-1.93,6.07,6.07,0,0,0,2.38-4.94,4.91,4.91,0,0,0-2-4.28,8.66,8.66,0,0,0-5.12-1.4,11.37,11.37,0,0,0-5.78,1.47,11.49,11.49,0,0,0-4.17,4.14L174,142.32a11.15,11.15,0,0,1,2.8-2.91,19.43,19.43,0,0,1,4-2.25,24.9,24.9,0,0,1,4.8-1.47,26.84,26.84,0,0,1,5.33-.52,21.86,21.86,0,0,1,6.52.91,16.54,16.54,0,0,1,5.08,2.52,10.82,10.82,0,0,1,4.45,9,12.55,12.55,0,0,1-.63,4A11.3,11.3,0,0,1,204.5,155a11,11,0,0,1-2.84,2.6A9.82,9.82,0,0,1,198.05,159Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.08,200.06v1.56l-6.35,0-.06-9.15,6.24,0V194l-4.46,0v2.2l3.86,0v1.44l-3.85,0,0,2.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.48,201.61l0-9.15,4,0a2.57,2.57,0,0,1,1.17.25,3.17,3.17,0,0,1,.92.69,3.33,3.33,0,0,1,.62,1,3.09,3.09,0,0,1-.21,2.72,2.61,2.61,0,0,1-1.2,1.06l2.11,3.42-2,0L101,198.52H99.24l0,3.07ZM99.23,197h2.23a.93.93,0,0,0,.46-.12,1.1,1.1,0,0,0,.36-.32,1.6,1.6,0,0,0,.24-.47,1.81,1.81,0,0,0,.09-.58,1.63,1.63,0,0,0-.11-.59,1.47,1.47,0,0,0-.28-.47,1.2,1.2,0,0,0-.4-.31.93.93,0,0,0-.46-.1H99.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.05,201.56l-.06-9.15,4.05,0a2.71,2.71,0,0,1,1.17.26,3,3,0,0,1,.92.69,3.11,3.11,0,0,1,.61,1,2.86,2.86,0,0,1,.23,1.1,3.12,3.12,0,0,1-.43,1.62,2.59,2.59,0,0,1-1.2,1.05l2.11,3.43h-2l-1.89-3.05h-1.75l0,3.07Zm1.75-4.64H110a1.09,1.09,0,0,0,.46-.12,1.22,1.22,0,0,0,.36-.32,1.6,1.6,0,0,0,.24-.47,1.85,1.85,0,0,0,.09-.58,1.64,1.64,0,0,0-.11-.6,1.53,1.53,0,0,0-.28-.46,1.08,1.08,0,0,0-.4-.31,1.07,1.07,0,0,0-.46-.11l-2.15,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.52,201.54a4,4,0,0,1-1.82-.38,4.43,4.43,0,0,1-1.41-1,4.66,4.66,0,0,1-.92-1.49,4.56,4.56,0,0,1-.33-1.71,4.36,4.36,0,0,1,.33-1.75,4.68,4.68,0,0,1,.93-1.49,4.43,4.43,0,0,1,1.42-1,4.07,4.07,0,0,1,1.78-.39,3.92,3.92,0,0,1,1.82.39,4.59,4.59,0,0,1,1.4,1.06,4.81,4.81,0,0,1,.91,1.49,4.76,4.76,0,0,1,.34,1.69,4.69,4.69,0,0,1-.33,1.75,4.79,4.79,0,0,1-.92,1.48,4.4,4.4,0,0,1-1.41,1A4.11,4.11,0,0,1,118.52,201.54Zm-2.68-4.62a3.7,3.7,0,0,0,.19,1.15,2.94,2.94,0,0,0,.53,1,2.43,2.43,0,0,0,.84.68,2.61,2.61,0,0,0,2.27,0,2.68,2.68,0,0,0,.83-.71,3.32,3.32,0,0,0,.51-1,3.47,3.47,0,0,0,.16-1.11,3.43,3.43,0,0,0-.19-1.15,3.25,3.25,0,0,0-.53-1,2.44,2.44,0,0,0-.85-.67,2.39,2.39,0,0,0-1.11-.25,2.41,2.41,0,0,0-1.15.27,2.56,2.56,0,0,0-.83.7,3.08,3.08,0,0,0-.5,1A3.48,3.48,0,0,0,115.84,196.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.36,201.44l-.06-9.14,4,0a2.57,2.57,0,0,1,1.17.26,3,3,0,0,1,.92.69,3.06,3.06,0,0,1,.61,1,2.89,2.89,0,0,1,.23,1.1,3.07,3.07,0,0,1-.43,1.62,2.61,2.61,0,0,1-1.2,1.06l2.11,3.43h-2l-1.89-3h-1.75l0,3.06Zm1.75-4.63,2.23,0a1.07,1.07,0,0,0,.46-.11,1.22,1.22,0,0,0,.36-.32,1.73,1.73,0,0,0,.24-.47,1.92,1.92,0,0,0,.09-.59,1.63,1.63,0,0,0-.11-.59,1.58,1.58,0,0,0-.28-.47,1.17,1.17,0,0,0-.4-.3,1,1,0,0,0-.46-.11h-2.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136,201.37l-.06-9.15,6.15,0v1.56l-4.37,0,0,2.36,3.63,0v1.44l-3.63,0,0,3.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.11,201.37a4.18,4.18,0,0,1-1.82-.38,4.46,4.46,0,0,1-1.41-1,4.79,4.79,0,0,1-1.25-3.19A4.41,4.41,0,0,1,143,195a4.64,4.64,0,0,1,.93-1.48,4.33,4.33,0,0,1,3.21-1.43,4,4,0,0,1,1.81.4,4.3,4.3,0,0,1,1.4,1,4.74,4.74,0,0,1,.91,1.49,4.81,4.81,0,0,1,.34,1.7,4.73,4.73,0,0,1-.33,1.75,4.68,4.68,0,0,1-.92,1.47,4.33,4.33,0,0,1-3.2,1.42Zm-2.68-4.62a3.68,3.68,0,0,0,.19,1.14,3,3,0,0,0,.53,1,2.65,2.65,0,0,0,.84.68,2.44,2.44,0,0,0,1.13.25,2.59,2.59,0,0,0,1.14-.27,2.7,2.7,0,0,0,.83-.71,3,3,0,0,0,.51-1,3.9,3.9,0,0,0,.17-1.12,3.69,3.69,0,0,0-.2-1.14,3,3,0,0,0-.53-1,2.62,2.62,0,0,0-.84-.67,2.45,2.45,0,0,0-1.12-.24,2.34,2.34,0,0,0-1.14.27,2.5,2.5,0,0,0-.84.7,3,3,0,0,0-.5,1A3.58,3.58,0,0,0,144.43,196.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153,201.27l0-9.15,4,0a2.57,2.57,0,0,1,1.17.25,3.17,3.17,0,0,1,.92.69,3.33,3.33,0,0,1,.62,1,3.09,3.09,0,0,1-.21,2.72,2.61,2.61,0,0,1-1.2,1.06l2.11,3.42-2,0-1.89-3.06h-1.75l0,3.07Zm1.75-4.64h2.23a.93.93,0,0,0,.46-.12,1.1,1.1,0,0,0,.36-.32,1.39,1.39,0,0,0,.24-.47,1.81,1.81,0,0,0,.09-.58,1.59,1.59,0,0,0-.11-.59,1.47,1.47,0,0,0-.28-.47,1.2,1.2,0,0,0-.4-.31,1.07,1.07,0,0,0-.46-.11l-2.15,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.88,198.81a2.19,2.19,0,0,1-.23,1,2.13,2.13,0,0,1-.63.74,3.17,3.17,0,0,1-.94.46,4.24,4.24,0,0,1-1.14.16l-4.42,0-.06-9.15,4.9,0a1.73,1.73,0,0,1,.86.2,2,2,0,0,1,.66.53,2.39,2.39,0,0,1,.43.74,2.54,2.54,0,0,1-.18,2.11,2,2,0,0,1-1,.87,2.28,2.28,0,0,1,1.72,2.32Zm-5.63-5.23v2.3h2.38a1,1,0,0,0,.76-.32,1.13,1.13,0,0,0,.31-.85,1.16,1.16,0,0,0-.29-.83,1,1,0,0,0-.72-.31Zm3.83,4.91a1.28,1.28,0,0,0-.31-.86,1.27,1.27,0,0,0-.34-.27,1,1,0,0,0-.42-.09l-2.74,0,0,2.41,2.64,0a1.18,1.18,0,0,0,.46-.09,1,1,0,0,0,.36-.26A1,1,0,0,0,167,199,1.18,1.18,0,0,0,167.08,198.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.28,201.16l-.05-9.15H172l.06,9.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174,201.14l-.06-9.15,3.32,0a5,5,0,0,1,2,.35,4,4,0,0,1,2.28,2.41,5.47,5.47,0,0,1,.29,1.77,5.36,5.36,0,0,1-.3,1.89,4,4,0,0,1-.9,1.45,4.1,4.1,0,0,1-1.42.94,5.18,5.18,0,0,1-1.86.34Zm6-4.62a3.57,3.57,0,0,0-.19-1.21,2.8,2.8,0,0,0-.53-1,2.44,2.44,0,0,0-.86-.61,3,3,0,0,0-1.16-.21H175.7l0,6h1.54a2.72,2.72,0,0,0,1.17-.24,2.44,2.44,0,0,0,.84-.64,2.83,2.83,0,0,0,.52-1A3.85,3.85,0,0,0,180,196.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.19,201.08l-.05-9.14,3.32,0a5.21,5.21,0,0,1,2,.35,4.08,4.08,0,0,1,1.41,1,4,4,0,0,1,.86,1.45,5.64,5.64,0,0,1,0,3.66,3.94,3.94,0,0,1-.9,1.45,4,4,0,0,1-1.41.93,5,5,0,0,1-1.86.34Zm6-4.62a4.2,4.2,0,0,0-.19-1.21,2.66,2.66,0,0,0-.53-.95,2.47,2.47,0,0,0-.87-.62,3,3,0,0,0-1.15-.21h-1.55l0,6h1.55a2.67,2.67,0,0,0,1.16-.24,2.36,2.36,0,0,0,.85-.64,2.76,2.76,0,0,0,.51-1A3.87,3.87,0,0,0,189.21,196.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.76,199.43V201l-6.35,0-.06-9.15,6.24,0v1.56l-4.46,0v2.2l3.86,0v1.44l-3.85,0,0,2.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.9,195.1l0,5.87h-1.78l-.06-9.15h1.38l4.81,6,0-6,1.78,0,.06,9.14h-1.45Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Cones--inject-23"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M88,405.76H50.67l13.87-48.24a5.08,5.08,0,0,1,9.55,0Z",
    style: {
      fill: "#009595"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "78.61 373.27 60.01 373.27 62.93 363.1 75.7 363.1 78.61 373.27",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "83.47 390.15 55.16 390.15 58.08 379.97 80.54 379.97 83.47 390.15",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88,405.76H50.67l13.2-45.93c-1.13,29.72,17.41,39.05,22.69,41.1Z",
    style: {
      opacity: 0.1,
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 43.58,
    y: 405.76,
    width: 51.46,
    height: 3.21,
    style: {
      fill: "#009595"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.53,405.76H401.24l13.87-48.24a5.08,5.08,0,0,1,9.55,0Z",
    style: {
      fill: "#009595"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "429.19 373.27 410.58 373.27 413.5 363.1 426.27 363.1 429.19 373.27",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "434.04 390.15 405.73 390.15 408.65 379.97 431.11 379.97 434.04 390.15",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.52,405.76H401.24l13.2-45.93c-1.13,29.72,17.41,39.05,22.69,41.1Z",
    style: {
      opacity: 0.1,
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 394.15,
    y: 405.76,
    width: 51.46,
    height: 3.21,
    style: {
      fill: "#009595"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-23"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M245.49,451.89c2.4.77,73.13-.11,75.71-1.8,1-.62-4-67.17-4-67.17l-45.7.45,4.86,44.53s-26,12-28.64,14.19S243.1,451.13,245.49,451.89Z",
    style: {
      fill: "rgb(247, 169, 160)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.5,451.89c2.39.77,73.13-.11,75.7-1.8.46-.28-.35-14.57-1.35-29.88H275.54l.84,7.68s-26,12-28.65,14.2S243.09,451.12,245.5,451.89Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.72,452.86c2.52.83,73.94.15,76.67-1.61,1-.66-.47-24.21-.47-24.35H276.74l0,.79s-27.46,12.59-30.25,14.85S242.19,452.05,244.72,452.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.91,450.06c12.14-.41,61.13-.92,73.16-.41.1,0,.1.07,0,.08-12,.67-61,.79-73.16.53C244.65,450.25,244.65,450.07,244.91,450.06Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.57,427.08c4.77-.93,10.62-.25,14.3,3.12.14.13,0,.33-.2.28a67.41,67.41,0,0,0-14.08-2.79A.31.31,0,0,1,271.57,427.08Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.14,429.19c4.77-.93,10.62-.25,14.3,3.12.14.13,0,.33-.2.28a67.44,67.44,0,0,0-14.07-2.79A.31.31,0,0,1,268.14,429.19Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.71,431.3c4.77-.93,10.62-.25,14.3,3.12.15.13,0,.33-.2.28a67.31,67.31,0,0,0-14.07-2.79A.31.31,0,0,1,264.71,431.3Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.76,426H321S312.75,311.89,313,310.36c.5-2.57,3.4-14.21,7.27-29.41,1.21-4.75,2.52-9.85,3.88-15.14,3.67-14.3,7.71-29.93,11.23-43.53,5.29-20.37,9.42-36.2,9.42-36.2h-41.7s-4.87,15.41-11,35.46c-10,32.58-23.32,77.42-24.64,88.33C265.91,323.07,271.76,426,271.76,426Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.05,417c7.5-.15,5.34-.21,12.85-.28,3.67,0,27.8-.25,31.23.32a.08.08,0,0,1,0,.15c-3.43.57-27.56.36-31.23.32-7.51-.07-5.35-.13-12.85-.29A.11.11,0,1,1,274.05,417Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.26,191.74l-7.65,26.94-7.46,27c-2.49,9-4.88,18-7.28,27s-4.75,18.06-7,27.14c-.53,2.28-1.07,4.55-1.52,6.85-.12.58-.2,1.17-.31,1.76,0,.32-.05.67-.05,1l.07.87,6.54,99.4,0,.3.55-.34-6-99.44-.06-.87c0-.28,0-.51,0-.77.11-.56.18-1.12.3-1.69.45-2.27,1-4.54,1.54-6.81,4.37-18.13,9.25-36.16,14-54.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.14,186.08c2.89,22.4,13.37,59.62,17.39,90.09,9.41-36.92,23.31-90.09,23.31-90.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.66,451.53c-2.42.76-61.83,1-64.41-.7-1-.64-1.34-10.65-1.41-22.77v-.38c0-2.5-5.77-44.46-5.77-44.46l44.89.92,5.19,44.07,0,.75s16.76,10.51,19.39,12.7S407.07,450.79,404.66,451.53Z",
    style: {
      fill: "rgb(247, 169, 160)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338,420.21c.51,4,.83,6.87.83,7.47v.38c.08,12.12.43,22.13,1.42,22.77,2.57,1.72,62,1.46,64.41.71s.46-7.7-2.16-9.88S383.11,429,383.11,429l0-.75-.95-8Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.59,452.86c-2.52.83-66.42.15-69.14-1.61-1.05-.66.46-24.21.46-24.35h44.18l0,.79s19.93,12.59,22.72,14.85S410.11,452.05,407.59,452.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.4,450.06c-12.14-.41-53.61-.92-65.64-.41-.09,0-.09.07,0,.08,12,.67,53.5.79,65.64.53C407.65,450.25,407.66,450.07,407.4,450.06Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.51,428.39c-6.05-1.67-13.59-1.66-18.5,1.66-.19.13,0,.38.24.35a94,94,0,0,1,18.19-1.33A.34.34,0,0,0,379.51,428.39Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.78,431.21c-6.06-1.67-13.59-1.66-18.5,1.67-.19.12,0,.37.24.34a95.62,95.62,0,0,1,18.19-1.33A.34.34,0,0,0,383.78,431.21Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388,434c-6.05-1.67-13.58-1.66-18.49,1.67-.19.13,0,.38.24.34A95.56,95.56,0,0,1,388,434.71.34.34,0,0,0,388,434Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.14,186.08s6.32,38.55,6.75,39.79c0,0,2.35,1.11,6.59,3.07l17.29,196.88,49.45.2L358.1,186.08Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.47,417c7.55-.12,5.38-.2,12.94-.24,3.7,0,28-.12,31.44.46a.08.08,0,0,1,0,.16c-3.46.55-27.75.24-31.45.19-7.55-.11-5.38-.16-12.93-.35A.11.11,0,0,1,336.47,417Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.84,224.67A92.28,92.28,0,0,1,323,232.08a.16.16,0,0,1-.15.29c-4.77-2.32-9.64-4.55-14.27-7.13A.32.32,0,0,1,308.84,224.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.65,202.59c.78,4.61,1.21,9.3,1.73,13.95.13,1.11.26,2.23.38,3.34a6.49,6.49,0,0,0,.8,2.93c1,1.56,2.8,2.29,4.43,3,.19.08.11.38-.09.31a10.72,10.72,0,0,1-4.71-2.48c-1.48-1.57-1.43-3.95-1.66-6a128.47,128.47,0,0,1-1.09-15.06C310.44,202.5,310.63,202.47,310.65,202.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.26,204c.17,3.32.54,6.64.81,10,.14,1.63.26,3.27.36,4.91s.29,3.37.24,5c0,.11-.18.14-.2,0-.28-1.57-.31-3.22-.44-4.81s-.26-3.36-.35-5c-.19-3.36-.28-6.74-.58-10.09C316.09,203.9,316.26,203.9,316.26,204Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "318.49 233.88 321.14 256.5 323.9 279.11 329.59 324.3 339.69 412.53 330.64 324.17 324.71 279 321.65 256.43 318.49 233.88",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.66,125.35c-23.79,19.53-50.76,55.42-45.15,69,3.78,9.13,30.23-17.11,30.31-18.63.06-1.15,14.27-28.33,22.86-44.88S312.63,121.27,307.66,125.35Z",
    style: {
      fill: "rgb(247, 169, 160)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.66,125.35c-23.79,19.53-50.76,55.42-45.15,69,3.78,9.13,30.23-17.11,30.31-18.63.06-1.15,14.27-28.33,22.86-44.88S312.63,121.27,307.66,125.35Z",
    style: {
      fill: "#009595"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.68,130.79c-8.59,16.54-22.8,43.73-22.87,44.88,0,.82-7.68,8.75-15.34,14.52l40.68-69.52C319.29,121.58,319,124.45,315.68,130.79Z",
    style: {
      fill: "#000102",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.11,203.43H360c.18-.22,2.35-5.06,2-7.21-1.12-7.65-19.41-64.66-27.91-74.31-4.82-5.48-15.88-3.59-18.55,0-11.42,15.5-20,63.6-20.18,74.69C295.35,199,298,203.25,298.11,203.43Z",
    style: {
      fill: "#009595"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "322.6 137.24 319.13 131.34 315.36 135.97 316.6 140.29 320.6 140.57 322.6 137.24",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "320.6 140.57 322.65 184.76 314.91 197.9 309.73 184.26 316.6 140.29 320.6 140.57",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.13,131.34c-.43,3-.8,6-1.16,9.07s-.72,6-1,9.07c-.64,6.05-1.24,12.11-1.63,18.18s-.7,12.14-.66,18.22c0,3,.13,6.08.43,9.1a41.3,41.3,0,0,0,1.66,9c-2.06-5.77-2.47-12-2.67-18s.1-12.2.49-18.29,1.05-12.14,1.81-18.19c.39-3,.8-6,1.25-9S318.58,134.34,319.13,131.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.63,162.83l-.12,0-7.25-2.53-1.06-10.7,12.29-.55,1.05,10.47Zm-6.91-2.94,6.83,2.39,4.47-3-1-9.71-11.29.51Z",
    style: {
      fill: "#000102",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.3,162.86l-3.42-3.4L304.6,149l8.57.57-.72,10.66Zm-2.91-3.6,3,3,4.57-2.33.67-9.88-7.57-.5Z",
    style: {
      fill: "#000102",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "313.21 148.65 305.09 147.89 305.45 146.22 313.21 147.03 313.21 148.65",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.66,143.36a21,21,0,0,0,.42,3.58c.29.74,2.4,1.05,2.4,1.05s1.84-.56,2-1.13a22.44,22.44,0,0,0-.28-3.79,3.09,3.09,0,0,1-2.57-1A2.15,2.15,0,0,1,328.66,143.36Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 296.69,
    y: 203.43,
    width: 63.94,
    height: 4.92,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.06,209.8H309V202h14.05Zm-12.05-2h10.05V204H311Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.71,125.5c25,18,54.13,52.12,49.38,66-3.2,9.34-31.24-15.18-31.42-16.69-.13-1.15-16-27.39-25.63-43.36S337.48,121.73,342.71,125.5Z",
    style: {
      fill: "rgb(247, 169, 160)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.71,125.5c25,18,54.13,52.12,49.38,66-3.2,9.34-31.24-15.18-31.42-16.69-.13-1.15-16-27.39-25.63-43.36S337.48,121.73,342.71,125.5Z",
    style: {
      fill: "#009595"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.06,138.11c2,2.95,3.86,6,5.73,9s3.69,6.06,5.5,9.11,3.58,6.12,5.31,9.22l2.58,4.66c.83,1.57,1.69,3.13,2.49,4.72-1-1.47-1.93-3-2.9-4.46L355,165.82c-1.88-3-3.7-6.06-5.51-9.11s-3.58-6.13-5.3-9.23S340.69,141.27,339.06,138.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.47,141.42c.73.67,1.39,1.38,2,2.08l1,1.07c.33.36.66.71,1,1.09a8.54,8.54,0,0,1-2.32-1.82A9.89,9.89,0,0,1,339.47,141.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 261.18,
    y: 167.05,
    width: 129.92,
    height: 7.23,
    transform: "matrix(0.83, -0.56, 0.56, 0.83, -39.88, 209.71)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 287.28,
    y: 203.94,
    width: 24.74,
    height: 7.23,
    transform: "translate(305.99 -156.9) rotate(56.29)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.56,197.49c6.43,2.38,10.5.56,35.39-10.39,3.44-1.52,2-27.16-2-27.27-6.35-.18-25.15,9.77-26.4,10.52C261,176.7,260.19,195.88,264.56,197.49Z",
    style: {
      fill: "rgb(247, 169, 160)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.88,175.77c-.6,3.16-3.84,2.49-3.84,2.49a6,6,0,0,1,.79,4c-.49,2.42-4.49,2.71-4.49,2.71a7.48,7.48,0,0,1,.16,4.36c-.7,2.27-4.7,3.14-4.7,3.14a6.49,6.49,0,0,1-2.27,3.92c-3.31,2.52-9.26.3-13-1.14-5.61-2.13-13.23-8.91-15.18-10.16L293,160.79a17.08,17.08,0,0,1,6.94-.92,75.25,75.25,0,0,1,18.11,4.49C322.5,166.43,329.46,172.67,328.88,175.77Z",
    style: {
      fill: "rgb(247, 169, 160)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325,177.81c-3.29-2.95-7.28-4.76-11.15-6.8-.09,0-.16.1-.07.14,3.87,2,7.31,4.7,11.1,6.83A.1.1,0,0,0,325,177.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.37,184.64a10.94,10.94,0,0,0-2.64-1.45c-1-.45-1.94-.88-2.93-1.3q-2.94-1.26-6-2.35c-.09,0-.16.09-.07.13,2,.84,3.91,1.7,5.83,2.62,1,.45,1.92.92,2.88,1.39a14.14,14.14,0,0,0,2.76,1.22C321.38,184.93,321.49,184.73,321.37,184.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.72,192.45a7.94,7.94,0,0,0-2.45-1.18l-2.71-1.1c-1.8-.74-3.6-1.49-5.37-2.29-.09,0-.16.09-.07.13,1.8.83,3.58,1.68,5.39,2.49l2.67,1.18a7.5,7.5,0,0,0,2.5.86A.05.05,0,0,0,316.72,192.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.93,161.23l-6,35s-16.88,4.92-19.58.8-1.77-16.77,4.78-24.23C273.42,166.73,288.93,161.23,288.93,161.23Z",
    style: {
      fill: "#009595"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "283.29 162.48 294.15 158.6 288.48 195.48 278.07 197.9 283.29 162.48",
    style: {
      fill: "#009595"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283,164.67c-.18,2.69-.48,5.37-.79,8.05s-.68,5.34-1.06,8-.81,5.32-1.29,8l-.73,4c-.28,1.32-.52,2.65-.83,4,.08-1.35.23-2.69.35-4l.45-4c.3-2.68.68-5.34,1.06-8s.81-5.32,1.29-8S282.37,167.3,283,164.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.86,160.49c0-.64.09-1.27.15-1.91l.19.16c-1.77.78-3.56,1.46-5.35,2.19s-3.59,1.37-5.4,2l.33-.4-.16,1.08,0,.26-.25.12-6,2.82c-2,1-4,1.95-5.9,3a27.94,27.94,0,0,1,2.7-2c.93-.6,1.89-1.16,2.86-1.73,1.92-1.12,3.91-2.11,5.93-3.06l-.28.38.15-1.08,0-.3.28-.1q2.72-1,5.46-1.86c1.84-.56,3.66-1.17,5.52-1.68l.24-.07,0,.22C294.16,159.25,294,159.87,293.86,160.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.31,167.25a5.2,5.2,0,0,1,2-.92,5.34,5.34,0,0,1,2.18-.09c-.35.13-.69.22-1,.32l-1,.26-1,.23C274,167.12,273.68,167.2,273.31,167.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.91,193.48c-5.61,3.56-16.44,4-38.32-12.18-3-2.24,4-26.94,8-26.16,6.22,1.22,22.39,15,23.44,16.05C392.83,179.68,394.83,191,390.91,193.48Z",
    style: {
      fill: "rgb(247, 169, 160)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.63,140.6c-2.33,2.21,0,4.57,0,4.57a6.06,6.06,0,0,0-3.79,1.51c-1.77,1.73.17,5.25.17,5.25a7.43,7.43,0,0,0-3.75,2.24c-1.52,1.82-.08,5.65-.08,5.65a6.54,6.54,0,0,0-2.06,4c-.31,4.15,4.79,7.94,8.05,10.33,4.85,3.54,14.69,6.25,16.79,7.2l16.76-18.83a17,17,0,0,0-3-6.33,75.17,75.17,0,0,0-13.61-12.75C348.94,140.86,339.91,138.42,337.63,140.6Z",
    style: {
      fill: "rgb(247, 169, 160)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338,145c4.26,1.16,8,3.52,11.77,5.66a.08.08,0,0,1-.08.13c-3.77-2.17-7.92-3.57-11.77-5.6C337.83,145.09,337.9,144.92,338,145Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.27,151.71a11.7,11.7,0,0,1,2.65,1.43c.91.57,1.8,1.15,2.68,1.75,1.77,1.2,3.52,2.44,5.22,3.73.08,0,0,.18-.07.13-1.77-1.19-3.55-2.36-5.37-3.47-.91-.56-1.82-1.11-2.74-1.65a14.07,14.07,0,0,1-2.52-1.66A.16.16,0,0,1,334.27,151.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.25,159.87a7.93,7.93,0,0,1,2.32,1.41L335,163c1.6,1.11,3.21,2.22,4.85,3.27.08.05,0,.18-.08.13-1.67-1.06-3.36-2.09-5-3.17l-2.44-1.59a7.59,7.59,0,0,1-2.08-1.64A.05.05,0,0,1,330.25,159.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.67,184.9,376.78,165s8.65,6,11.87,11.35,6.2,12.19,3.49,16.16S377.34,199.34,356.67,184.9Z",
    style: {
      fill: "#009595"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "356.98 186.89 348.65 181.29 372.3 158.81 379.76 165.44 356.98 186.89",
    style: {
      fill: "#009595"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.5,186.4c1.63-1.82,3.34-3.56,5.06-5.29S366,177.7,367.8,176s3.56-3.32,5.39-4.93l2.76-2.4c.94-.78,1.86-1.57,2.83-2.33-.81.92-1.67,1.79-2.5,2.69l-2.56,2.6c-1.71,1.74-3.47,3.42-5.24,5.09s-3.56,3.32-5.4,4.93S359.41,184.88,357.5,186.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.61,160.38c.52-.57,1.06-1.12,1.59-1.67l.08-.08.1.08c1.31,1,2.57,2.12,3.86,3.18l3.77,3.27.3.26-.3.29-1,.92,0-.56a53.11,53.11,0,0,1,4.46,4,46.65,46.65,0,0,1,3.94,4.5c-1.42-1.39-2.85-2.77-4.32-4.1s-3-2.64-4.53-3.83l-.34-.25.32-.3c.32-.32.64-.63,1-.93v.54l-3.7-3.35c-1.2-1.15-2.43-2.27-3.62-3.45h.19C371.8,159.4,371.21,159.9,370.61,160.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.25,170.26a3.84,3.84,0,0,1,1.6.49,3.28,3.28,0,0,1,1.22,1.15,11.78,11.78,0,0,1-1.47-.71A7.75,7.75,0,0,1,383.25,170.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.76,180.23c-.32.4-.67.78-1,1.17l0-.23a71.62,71.62,0,0,1,8.38,5.51l-.29,0c.42-.31.84-.62,1.28-.91l.09-.06.06.05c.3.26.61.52.9.8l-1-.59h.16c-.37.38-.75.74-1.12,1.1l-.13.12-.17-.11a71.68,71.68,0,0,1-8.27-5.68l-.15-.12.13-.11C349,180.86,349.35,180.54,349.76,180.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.45,129.89c3.67,1.27,10.71-3.82,13.73-8.22.21-.3.06-3.71.08-7.87,0-2.53.1-5.34.36-7.9.06-.52-16.44,2.27-16.44,2.27a41.05,41.05,0,0,1,.55,10,6.36,6.36,0,0,1-.22,1s0,.11,0,.17C314.94,121.32,313.9,128.66,317.45,129.89Z",
    style: {
      fill: "rgb(247, 169, 160)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.63,105.87c-1.19,4.25-4.94,14.43-13.52,13.75a10.69,10.69,0,0,1-1.64-.25,1.72,1.72,0,0,1,0-.18,5.53,5.53,0,0,0,.22-1,41.1,41.1,0,0,0-.55-10S327.08,106.15,330.63,105.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.44,85.35c2,5.65-.46,22.27-4.4,26.1-5.7,5.55-15.32,6.41-20.12-.51-4.64-6.71-1.1-28.31,3.32-31.82C318.74,74,330.56,77,333.44,85.35Z",
    style: {
      fill: "rgb(247, 169, 160)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.28,95.59s.08.07.07.12c-.19,1.11-.23,2.42.73,2.94,0,0,0,.07,0,.06C319.85,98.36,319.92,96.62,320.28,95.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.44,94.57c1.82.11,1.46,3.75-.23,3.64S319.92,94.47,321.44,94.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.81,94.94s-.09,0-.09.09c-.08,1.12-.36,2.4-1.42,2.68,0,0,0,.06,0,.06C313.56,97.72,313.92,96,313.81,94.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.93,93.66c-1.8-.32-2.31,3.29-.65,3.59S314.43,93.93,312.93,93.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.74,92.35c-.5.14-1,.18-1.48.27a2.45,2.45,0,0,1-1.56,0,.77.77,0,0,1-.35-.87,1.94,1.94,0,0,1,1.58-1.13,2.86,2.86,0,0,1,2,.26A.82.82,0,0,1,323.74,92.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.32,91.65a13.34,13.34,0,0,0,1.44.43,2.5,2.5,0,0,0,1.55.15.78.78,0,0,0,.44-.84,1.9,1.9,0,0,0-1.45-1.28,2.79,2.79,0,0,0-2,0A.82.82,0,0,0,311.32,91.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.81,106.14c-.3.23-.6.57-1,.56a2.9,2.9,0,0,1-1.18-.4s-.08,0-.06,0a1.56,1.56,0,0,0,1.37.76,1.21,1.21,0,0,0,1-.91C319.94,106.14,319.85,106.1,319.81,106.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.83,104.71c-2.2-.55-4.82-.78-4.83-.91l.47-2.58c-.34.12-2,.69-2,.24A58.15,58.15,0,0,1,315.17,90a.11.11,0,0,1,.21,0c-.44,3.6-1.51,7.1-2,10.72a6.32,6.32,0,0,1,1.86-.37,24.61,24.61,0,0,1-.46,3,16.38,16.38,0,0,1,4.1,1.06C319,104.53,318.94,104.74,318.83,104.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.06,101.23c-2.46-.61-3.72-4.18-3.72-8.93,0-3.55-1-8.81-4.62-9.51-4-.78-5.77,2-8.27,1.84C314.16,84.49,314,82,312.27,82s-2.86,2-3.85,5.24c1-3.88,2.22-7.53,3.67-8.68,6.51-5.17,18.9-2.44,21.78,5.9C335,87.67,334.25,95.3,333.06,101.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.4,98.93s3.65-5.4,6.1-4.11-.24,9.08-3.07,10.19a2.89,2.89,0,0,1-3.9-1.49Z",
    style: {
      fill: "rgb(247, 169, 160)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.67,97a0,0,0,0,1,0,.07c-2,.84-3,2.71-3.71,4.64a1.6,1.6,0,0,1,2.39-.48c.05,0,0,.12-.06.11a1.78,1.78,0,0,0-1.95.66,8.7,8.7,0,0,0-.91,1.6c-.09.18-.41.09-.35-.12l0,0C331,100.93,333,97.34,335.67,97Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.27,119.7l4.21,9.81,12-12.71,3.55,3.93s-11.56,20-11.66,19.15l-4.23-8.41-5.74,6,.17-14.84Z",
    style: {
      fill: "#009595"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.05,130.16c.11-2.45.16-4.92.38-7.36,0-.08.14-.13.17,0,.53,2.35.06,11.71.12,13.95l0,0c.24-.26,5.33-5.31,5.38-5.23.91,1.33,4,7.45,4.23,8,1.83-3.18,8.85-14.76,11-17.78a.09.09,0,0,1,.15.08c-1.61,3.36-10.89,18.95-11,18.9a94.52,94.52,0,0,1-4.43-8.88c-.86,1.09-6,6.77-6,6.41A77.2,77.2,0,0,1,313.05,130.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.78,88.8c-.39.61-2.92.16-3.28.27,0,0-1.85,1.46-1.85,1.46s-10.1-8.66-12.59-9.48-13.7-.28-13.7-.28l-1.24-5.37s-4.77-3.4-5-5.86c-.15-1.47,12-5.2,21.52-1.72C335.67,72.24,341.9,85.48,339.78,88.8Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.51,89.07s-1.86,1.45-1.86,1.45-10.1-8.65-12.59-9.47-13.7-.28-13.7-.28-1.19-4.93-1.24-5.37c0,0,13.06-1.47,17.17,1.52S334.16,84.43,336.51,89.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.06,74.62a28,28,0,0,0,.67,3.46c.29.74,2.15,1.18,2.15,1.18s1.84-.56,2-1.14a22.67,22.67,0,0,0-.27-3.79,3.11,3.11,0,0,1-2.58-1A2.13,2.13,0,0,1,311.06,74.62Z",
    style: {
      fill: "#009595"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.65,90.53S329,87.77,325,87.35c-3.39-.36-12.87-.92-15.51-.79-3.85.18-9.9-4.47-8.43-5.82,2.44-2.26,17.88-.78,21.09.21C327.06,82.46,334.65,90.53,334.65,90.53Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.55,88.44a1,1,0,1,0,.93-1.12A1,1,0,0,0,332.55,88.44Z",
    style: {
      fill: "#ebebeb"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg403Error);
export default __webpack_public_path__ + "static/media/403_Error.4a747b9174c856a34a71a82087000800.svg";
export { ForwardRef as ReactComponent };